import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import PageLoader from "../../../../../components/PageLoader";
import { selectsubscriptionsListItems } from "../../../../../redux/subscriptions/selector";
import { subscriptions } from "../../../../../redux/subscriptions/action";
import TenantSubscriptionInfoComponent from "../components/tenant-subscription-info.component";

const TenantSubscriptionDetailComponent = ({ tenantsDetails }: any) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const subscriptionsItems = useSelector(selectsubscriptionsListItems);
    const [isModalOpen, setModalOpen] = useState(false);

    const fetchSubscriptions = () => {
        dispatch(
            subscriptions.list({
                url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/subscriptions/list`,
                entity: "subscriptions",
                jsonData: {
                    Filters: [
                        {
                            FieldName: "PrimaryTenantId",
                            FilterOperatorId: 1,
                            FieldValue: tenantsDetails?.Id,
                            FieldType: "number",
                        },
                    ],
                    PageNumber: 1,
                    PageSize: 10,
                    SortField: "Id",
                    SortOrder: "desc",
                },
            })
        );
    };

    useEffect(() => {
        fetchSubscriptions();
    }, []);

    // Check if there are subscription items
    const hasSubscriptionItems = !!subscriptionsItems?.result?.items?.length;

    useEffect(() => {
        // Show or hide modal based on subscription item availability
        if (!hasSubscriptionItems && !subscriptionsItems?.isLoading) {
            setModalOpen(true);
        } else {
            setModalOpen(false);
        }
    }, [hasSubscriptionItems, subscriptionsItems?.isLoading]);

    const enableSubscription = () => {
        navigate(
            `/management/platform-management/tenants/${tenantsDetails?.CompanyName}/enable-subscription`
        );
    };

    const closeModal = () => {
        setModalOpen(false);
    };

    return (
        <>
            {subscriptionsItems?.isLoading ? (
                <PageLoader />
            ) : (
                <>
                    {isModalOpen && (
                        <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
                            <div className="relative bg-white shadow-md p-6 w-80 rounded-lg">
                                <button
                                    onClick={closeModal}
                                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-900"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6 18L18 6M6 6l12 12"
                                        />
                                    </svg>
                                </button>
                                <p className="text-center text-lg text-gray-800 mb-4">
                                    Please enable subscription
                                </p>
                                <div className="flex justify-center">
                                    <button
                                        className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg"
                                        onClick={enableSubscription}
                                    >
                                        Enable Subscription
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {!isModalOpen && hasSubscriptionItems && (
                        <TenantSubscriptionInfoComponent
                            tenantsDetails={subscriptionsItems?.result?.items[0]}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default TenantSubscriptionDetailComponent;
